export default __webpack_public_path__ + "6ee2c6b5c7074dff8a7cd92a648394bf.svg";